const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

export async function getPartners() {
  const res = await fetch(`${apiUrl}/api/partners-list`);
  return res.json();
}